// The Effect edge of the deployment profile: the one module that runs its read. The run hands React
// Query a Promise of the read's Result, so a refusal is data the shell renders (and React Query never
// retries a 401 as if it were a transient throw); a defect rejects the Promise and an aborted query
// interrupts its request.
import { queryOptions } from '@tanstack/react-query';
import { Effect, ManagedRuntime } from 'effect';
import type { Result } from 'effect';
import { FetchHttpClient } from 'effect/http';
import {
  deploymentQueryKeys,
  fetchDeploymentProfile,
} from '@finnest/power-admin-client/deployment';
import type { DeploymentProfileReadError } from '@finnest/power-admin-client/deployment';
import type { PowerDeploymentProfile } from '@finnest/power-admin-contracts';
import { resolvePowerAdminApiBaseUrl } from '../runtime/power-admin-api.ts';

const profileRuntime = ManagedRuntime.make(FetchHttpClient.layer);

/** What the profile read answered: the profile or why it could not be read. */
export type DeploymentProfileOutcome = Result.Result<
  PowerDeploymentProfile,
  DeploymentProfileReadError
>;

// The fetch is read per run, as the browser (or a test) has it now; the API base is resolved per
// run too.
const readProfile = (signal: AbortSignal): Promise<DeploymentProfileOutcome> =>
  profileRuntime.runPromise(
    Effect.suspend(() => fetchDeploymentProfile(resolvePowerAdminApiBaseUrl())).pipe(
      Effect.result,
      Effect.provideService(FetchHttpClient.Fetch, globalThis.fetch),
    ),
    { signal },
  );

// The deployment does not change under a running admin: the profile is read once per session, and
// again only when the operator asks after a failed read.
export const deploymentProfileQueryOptions = queryOptions({
  queryKey: deploymentQueryKeys.profile,
  queryFn: ({ signal }): Promise<DeploymentProfileOutcome> => readProfile(signal),
  staleTime: 'static',
  retry: false,
});
